import { safeFrameUrl } from '@/lib/products/safeFrameUrl';

const LOCAL_DAILY_STOCK_ANALYSIS_URL = 'http://127.0.0.1:8000';

export function getConfiguredDailyStockAnalysisUrl(): string | null {
  const runtimeUrl =
    typeof window !== 'undefined'
      ? window.__ENV?.VITE_DAILY_STOCK_ANALYSIS_URL
      : undefined;
  const configuredUrl =
    runtimeUrl || import.meta.env.VITE_DAILY_STOCK_ANALYSIS_URL;

  return safeFrameUrl(configuredUrl);
}

export function getDailyStockAnalysisUrl(
  isElectron: boolean,
  serviceUrl?: string
): string | null {
  if (isElectron) return serviceUrl || LOCAL_DAILY_STOCK_ANALYSIS_URL;
  return getConfiguredDailyStockAnalysisUrl();
}

export function isDailyStockAnalysisAvailable(): boolean {
  const isElectron =
    typeof window !== 'undefined' && Boolean(window.electronAPI?.services);
  return isElectron || Boolean(getConfiguredDailyStockAnalysisUrl());
}
